// This is a modal for Adminvendorstwo

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { RejectedRefferal } from "./redux/slices/ReferralsThunks";
import { useNavigate } from "react-router-dom";

export default function ModalAdminRejectReferral({ onClose, id }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");

  const rejectionReasons = [
    {
      value: "Job-seeking / employment request",
      label: "Job-seeking / employment request",
    },
    {
      value: "Self-promotion (no client referral)",
      label: "Self-promotion (no client referral)",
    },
    { value: "Non identifiable", label: "Non identifiable" },
    { value: "Outside scope", label: "Outside scope" },
    { value: "Test / duplicate", label: "Test / duplicate" },
    { value: "Abusive / fraudulent", label: "Abusive / fraudulent" },
  ];

  const handleReject = async () => {
    if (!reason) {
      setReasonError("Rejection reason is required.");
      return;
    }

    setReasonError(""); // clear if valid

    try {
      await dispatch(
        RejectedRefferal({
          id,
          status: "rejected",
          reject_reason: reason,
        })
      ).unwrap();

      navigate("/adminpendingreferrals");
    } catch (error) {
      console.error("Error rejecting referral:", error);
    }
  };

  return (
    <RootWrapperModalAdminvendorstwo>
      <Wrapper>
        <Sector>
          <Left>
            <Frame58>
              <Frame1391>
                <Tag>Rejection Reason</Tag>
              </Frame1391>

              {/** Rejection Reason Dropdown */}
              <Frame1391>
                <PRTNR.Select
                  label="Select Reason"
                  options={rejectionReasons}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  error={!!reasonError}
                  errorMessage={reasonError}
                />
              </Frame1391>

              <Frame59>
                {/** Cancel Button */}
                <AIMEButton
                  size="small"
                  onClick={onClose}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    borderRadius: "999px",
                    background: "rgb(241, 245, 249)",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "rgb(33, 37, 67)",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                    }}
                  >
                    Cancel
                  </span>
                </AIMEButton>

                {/** Reject Button */}
                <AIMEButton
                  size="small"
                  onClick={handleReject}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "48px",
                    width: "240px",
                    background: "rgb(220, 53, 69)", // red button for rejection
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                    }}
                  >
                    Reject
                  </span>
                </AIMEButton>
              </Frame59>
            </Frame58>
          </Left>
        </Sector>
      </Wrapper>
    </RootWrapperModalAdminvendorstwo>
  );
}

const RootWrapperModalAdminvendorstwo = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  border-radius: 32px;
  width: 534px;
  padding: 24px;
`;

const Sector = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 486px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 486px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Tag = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
